import React from 'react'
import styles from './NewsPage.module.css'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {
  SmartImg1,
  SmartImg2,
  SmartImg3,
} from '../../../Assets/Images/SmartManufacturingPage'

const SmartManufBlock = () => {
  const { t } = useTranslation()

  const posts = [
    {
      id: '1',
      full_picture: SmartImg1,
      message: 'CMS Technology Center',
      permalink_url: 'https://my.matterport.com/show/?m=chyfiKoYXpP',
      created_time: 'Prostir3D',
    },
    {
      id: '2',
      full_picture: SmartImg2,
      message: 'CMS JEC 2025',
      permalink_url: 'https://my.matterport.com/show/?m=whXj89Qrw5h',
      created_time: 'Prostir3D',
    },
    {
      id: '3',
      full_picture: SmartImg3,
      message: 'ADVANCED MATERIALS 2025',
      permalink_url: 'https://my.matterport.com/show/?m=CD7E54vHXZF',
      created_time: 'Prostir3D',
    },
  ]

  return (
    <div className={styles.posts}>
      <div className={`customContainer ${styles.text}`}>
        <h2 className={styles.title}>{t('smartpage.title')}</h2>
        <p className={styles.desc}>{t('smartpage.description')}</p>
      </div>

      <div className={`customContainer ${styles.postsGrid}`}>
        {posts.map((post) => (
          <Link
            to={post.permalink_url}
            target="_blank"
            key={post.id}
            className={styles.postItem}
          >
            {post.full_picture && (
              <img
                src={post.full_picture}
                alt="Post"
                className={styles.postImage}
              />
            )}
            <p className={styles.postAuthor}>{post.created_time}</p>
            <p className={styles.postMessage}>{post.message || 'Без опису'}</p>
          </Link>
        ))}
      </div>
    </div>
  )
}

export default SmartManufBlock
